import api from './client'
import type { ReviewCard, ReviewRating } from '@/types/review'

/** With `randomCount`, a random practice set from every card, due or not. */
export function fetchDueReviews(languageId: number, deckId?: number, randomCount?: number) {
  return api.get<{ data: ReviewCard[] }>('/reviews', {
    params: {
      language_id: languageId,
      ...(deckId !== undefined && { deck_id: deckId }),
      ...(randomCount !== undefined && { random_count: randomCount }),
    },
  })
}

export function submitReview(card: ReviewCard, rating: ReviewRating) {
  const target =
    card.type === 'word'
      ? { word_id: card.word.id }
      : { custom_flashcard_id: card.custom_flashcard.id }

  return api.post<{ success: boolean }>('/reviews', { ...target, rating })
}
